/* eslint-disable import/no-unresolved,import/extensions */
// @flow
import React, { Component, Fragment } from 'react';
import type { Node } from 'react';
import type { RouterHistory } from 'react-router-dom';
// $FlowFixMe - Typescript file
import env from 'bench-environment';

import 'common/lib/bootstrap/bootstrap-transition';
import 'common/lib/bootstrap/bootstrap-modal';
import 'common/lib/bootstrap/bootstrap-tooltip';
import 'common/lib/bootstrap/bootstrap-popover';
import 'common/lib/bootstrap/bootstrap-button';
import 'common/lib/bootstrap/bootstrap-tab';
import 'app-common/../img/jquery-themes/smoothness/jquery-ui-1.8.9.custom.css';
// $FlowFixMe
import 'app-client/../less/main.less';
import core from 'app-client/core.coffee';

import BackboneRouter from './BackboneRouter';

// Carried over from main-app BaseAction.java
function getNonImpersonatedRole(roles) {
  if (roles.includes('USER')) {
    return 'USER';
  } else if (roles.includes('TAX_ACCOUNTANT')) {
    return 'TAX_ACCOUNTANT';
  } else if (roles.includes('SALES')) {
    return 'SALES';
  }
  return '';
}

function redirectToLogin() {
  const localStorageOpenIdOkta = localStorage.getItem('openid_okta');
  const isOktaLogin = localStorageOpenIdOkta ? JSON.parse(localStorageOpenIdOkta) : false;
  const redirectEncoded = encodeURIComponent(window.location.href);
  const loginURL = isOktaLogin
    ? `${env.location.apiRoot}/oauth2/authorization/okta`
    : `${env.location.websiteRoot}/login`;
  window.location.href = `${loginURL}?redirect_url=${redirectEncoded}`;
}

const BackboneApplication = (clientId, history) =>
  fetch(`${env.location.apiRoot}/api/v1/security.json/user`, {
    credentials: 'include',
  })
    .then(response => response.json())
    .then(({ userId, roles }) => {
      if (typeof userId === 'undefined' || userId === null) {
        return redirectToLogin();
      }
      core.setCurrentUserId(userId);
      const nonImpersonatedRole = getNonImpersonatedRole(roles);
      return core.bootstrap(clientId, nonImpersonatedRole, () => {
        core.setRouter(new BackboneRouter());
        core.getRouter().setHistory(history);
      });
    });

export type FeatureFlags = {
  unifiedBanking: boolean,
};

export type Client = {
  id: string,
  company: string,
  countryCode: string,
  featureFlags: FeatureFlags,
};

type BackboneAppContainerProps = {
  clientId: string,
  history: RouterHistory,
  children: ({ isLoading: boolean, client: ?Client }) => Node,
};

type BackboneAppContainerState = {
  backboneAppLoaded: boolean,
  client: ?Client,
  error: ?string,
};

/**
 * This utility component bootstraps the old Backbone app (including wiring up the old router with
 * React-Router) and fetches the current client and user objects to be injected into the rest of
 * the app.
 */
export default class BackboneAppContainer extends Component<
  BackboneAppContainerProps,
  BackboneAppContainerState,
> {
  constructor(props: BackboneAppContainerProps) {
    super(props);

    this.state = {
      backboneAppLoaded: false,
      client: null,
      error: null,
    };
  }
  componentDidMount() {
    const clientPromise = fetch(
      `${env.location.apiRoot}/api/v1/client.json/${this.props.clientId}`,
      { credentials: 'include' },
    ).then(async resp => {
      if (!resp.ok) {
        const error = await resp.json();
        throw new Error(
          `Status: ${resp.status} Message: ${error?.messages?.[0]?.message}` ??
            'Failed to fetch client',
        );
      }
      return resp.json();
    });
    const featureFlagPromise = fetch(
      `${env.location.apiRoot}/api/v1/clientsettings.json/${this.props.clientId}`,
      { credentials: 'include' },
    ).then(async resp => {
      if (!resp.ok) {
        const error = await resp.json();
        throw new Error(
          `Status: ${resp.status} Message: ${error?.messages?.[0]?.message}` ??
            'Failed to fetch client settings',
        );
      }
      return resp.json();
    });
    Promise.all([clientPromise, featureFlagPromise])
      .then(([clientResponse, featureFlagResponse]) => {
        const client = clientResponse;
        client.featureFlags = featureFlagResponse.features;
        this.setState({ client });
      })
      .catch(error => {
        this.setState({ error: error.message });
      });

    BackboneApplication(this.props.clientId, this.props.history)
      .then(() => {
        this.setState({
          backboneAppLoaded: true,
        });
      })
      .catch(error => {
        this.setState({ backboneAppLoaded: true });
      });
  }

  render() {
    const { backboneAppLoaded, client, error } = this.state;

    return (
      <Fragment>
        {this.props.children({
          isLoading: !backboneAppLoaded || !client?.id,
          client,
          error,
        })}
      </Fragment>
    );
  }
}
